/* global daum */

export default {
  methods: {
    /**
     * Daum 우편번호 검색 기능
     * @param {string} wrapId - 검색창을 표시할 컨테이너 ID
     * @param {function} onComplete - 주소 선택 완료 시 콜백 함수
     */
    findAddressWithDaum(wrapId = 'searchPostCodeWrap', onComplete) {
      const elementWrap = document.getElementById(wrapId);
      if (!elementWrap) {
        console.error(`Element with id '${wrapId}' not found`);
        return;
      }

      // 현재 scroll 위치를 저장
      const currentScroll = Math.max(document.body.scrollTop, document.documentElement.scrollTop);

      daum.postcode.load(() => {
        new daum.Postcode({
          oncomplete(data) {
            // 주소 조합
            let fullAddr = data.address;
            let extraAddr = '';

            if (data.addressType === 'R') {
              if (data.bname !== '') {
                extraAddr += data.bname;
              }
              if (data.buildingName !== '') {
                extraAddr += (extraAddr !== '' ? `,${data.buildingName}` : data.buildingName);
              }
              fullAddr += (extraAddr !== '' ? `(${extraAddr})` : '');
            }

            // 콜백 함수 호출
            if (onComplete) {
              onComplete({
                zipcode: data.zonecode,
                address: fullAddr,
                originalData: data,
              });
            }

            // 검색창 숨기기
            elementWrap.style.display = 'none';

            // 스크롤 위치 복원
            document.body.scrollTop = currentScroll;
          },
          onresize(size) {
            elementWrap.style.height = `${size.height}px`;
          },
          width: '100%',
          height: '100%',
        }).embed(elementWrap);
      });

      // 검색창 표시
      elementWrap.style.display = 'block';
    },

    /**
     * 검색창 닫기
     * @param {string} wrapId - 검색창 컨테이너 ID
     */
    closeDaumPostcode(wrapId = 'searchPostCodeWrap') {
      const elementWrap = document.getElementById(wrapId);
      if (elementWrap) {
        elementWrap.style.display = 'none';
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/main/mixins/addressMixin.js